import { render } from "./field-edit.vue?vue&type=template&id=f2dfa4a4&scoped=true&ts=true"
import script from "./field-edit.vue?vue&type=script&lang=ts"
export * from "./field-edit.vue?vue&type=script&lang=ts"

import "./field-edit.vue?vue&type=style&index=0&id=f2dfa4a4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2dfa4a4"]])

export default __exports__